// export const apiPrefix = 'http://172.16.4.255:9010/mall_platform' // 本地环境
export const apiPrefix = 'https://m.xbyx.cloud/mall_platform' // 正式环境